import { OutlineButton } from "Components/HomeV2/Buttons";
import image from "../../Assets/AIOnDemand/drive-growth-bg.png";
import bgImage from "../../Assets/homev2/vod-bg.png";
const DriveGrowth = () => {
    return (
        <section
            className="w-full bg-cover overflow-hidden relative mb-10"
            style={{
                backgroundImage: `url(${bgImage})`,
            }}
        >
            <div className="w-full h-full max-w-[1500px] mx-auto px-4 pt-8 md:pt-20 pb-20 flex flex-col justify-between items-center">
                <div>
                    <h2 className="text-3xl md:text-5xl lg:text-7xl text-black font-semibold text-center flex items-start justify-center">
                        How We Drive Growth
                    </h2>
                    <h4 className="text-center w-[75%] mx-auto md:mx-0 md:w-fit text-black md:text-2xl mt-4">
                        Enterprise Sales Workflows. Optimized from Start to Finish.
                    </h4>
                    <div className="flex  max-w-[180px] whitespace-nowrap items-center flex-col md:flex-row gap-4 md:gap-6 md:max-w-max md:w-max mx-auto  mb-14 md:mb-0 mt-4 md:mt-10">
                        <a href="https://calendly.com/salesbox-meet/ai-ondemand" target="_blank" rel="noreferrer noopener" className="">
                            <OutlineButton theme="black" >See What’s Inside</OutlineButton>
                        </a>
                    </div>
                </div>
                <div
                    // onClick={() => setShowOverlay(true)}
                    className="w-full max-w-[1100px]   md:mt-10"
                >
                    <img src={image} alt="" width="100%" height="100%" loading="lazy" />
                </div>
            </div>
        </section>
    );
}

export default DriveGrowth;